export default __webpack_public_path__ + "static/media/goshen92.9f056dbb.jpg";